import * as React from 'react';
import './LoadingSection.scss';
interface ILoadingSectionProps {
  height?: number | string;
  width?: number | string;
}

export const LoadingSection: React.FunctionComponent<ILoadingSectionProps> = (
  props
) => {
  return (
    <div
      className="rc-w-full rc-h-full rc-bg-gradient-to-r rc-from-light-300 rc-from-25% rc-via-light-200 rc-to-light-300 rc-to-75% rc-rounded-md rc-animate-pulse"
      style={{ height: props.height, width: props.width }}
    ></div>
  );
};
